export default __webpack_public_path__ + "static/media/social-proof-thumbnail.a58f6147.png";